if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    static #STORAGE_KEY = 'theme:recently-viewed-products';

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.isPreviewMode = this.dataset.isPreviewMode === 'true';
      this.excludeId = this.dataset.excludeId ? parseInt(this.dataset.excludeId) : null;
      this.productsToShow = parseInt(this.dataset.productsToShow) || 6;
      this.wrapper = document.querySelector(`[data-recently-viewed-wrapper="${this.sectionId}"]`);

      this.renderTimeout = setTimeout(() => this.renderRecentlyViewedProducts(), 100);

      if (window.Shopify?.designMode) {
        this.sectionLoadHandler = () => {
          clearTimeout(this.renderTimeout);
          this.renderTimeout = setTimeout(() => this.renderRecentlyViewedProducts(), 100);
        };
        document.addEventListener('shopify:section:load', this.sectionLoadHandler);
      }
    }

    async renderRecentlyViewedProducts() {
      try {
        const viewed = JSON.parse(
          localStorage.getItem(RecentlyViewedProducts.#STORAGE_KEY) || '[]'
        );

        if (!viewed.length && !this.isPreviewMode) {
          this.#hide();
          return;
        }

        const items = new Set(viewed);

        if (this.excludeId !== null) {
          items.delete(this.excludeId);
        }

        if (!items.size && !this.isPreviewMode) {
          this.#hide();
          return;
        }

        const queryString = Array.from(items)
          .map((id) => `id:${id}`)
          .slice(0, this.productsToShow)
          .join(' OR ');

        const url = `${window.Shopify.routes.root}search?type=product&q=${encodeURIComponent(queryString)}&section_id=${this.sectionId}`;

        const response = await fetch(url);
        if (!response.ok) throw new Error(`Fetch failed: ${response.status}`);

        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const newContent = tempDiv.querySelector('recently-viewed-products');

        if (newContent && newContent.childElementCount > 0) {
          this.replaceChildren(...newContent.childNodes);
          this.#show();
          window.eventBus?.emit('recentlyViewed:updated');
        } else {
          if (!this.isPreviewMode) this.#hide();
        }
      } catch (e) {
        console.error('Recently viewed products error:', e);
        if (!this.isPreviewMode) this.#hide();
      }
    }

    #show() {
      if (this.wrapper) this.wrapper.style.display = '';
    }

    #hide() {
      if (this.wrapper) this.wrapper.style.display = 'none';
    }

    disconnectedCallback() {
      clearTimeout(this.renderTimeout);
      if (this.sectionLoadHandler) {
        document.removeEventListener('shopify:section:load', this.sectionLoadHandler);
      }
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
